"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const assets_1 = require("~/assets");
const Carousel_module_scss_1 = __importDefault(require("./Carousel.module.scss"));
const Image_1 = __importDefault(require("../Image"));
const Carousel = (0, react_1.forwardRef)(({ children }, ref) => {
    const [scrollPosition, setScrollPosition] = (0, react_1.useState)(0);
    const [maxScroll, setMaxScroll] = (0, react_1.useState)(0);
    const scrollableContainer = ref;
    const widgetContent = '#widget-content';
    const handlePrev = () => {
        var _a;
        const widgetWidth = (_a = document.querySelector(widgetContent)) === null || _a === void 0 ? void 0 : _a.clientWidth;
        if (scrollableContainer.current && widgetWidth) {
            scrollableContainer.current.scrollLeft -= widgetWidth / 2;
        }
    };
    const handleNext = () => {
        var _a;
        const widgetWidth = (_a = document.querySelector(widgetContent)) === null || _a === void 0 ? void 0 : _a.clientWidth;
        if (scrollableContainer.current && widgetWidth) {
            scrollableContainer.current.scrollLeft += (widgetWidth + 10) / 2;
        }
    };
    const getCurrentScrollPosition = () => {
        if (scrollableContainer.current) {
            return scrollableContainer.current.scrollLeft;
        }
        return 0;
    };
    const handleChange = () => {
        const { current } = scrollableContainer;
        if (!current) {
            return;
        }
        const curretnMaxScroll = current.scrollWidth - current.clientWidth;
        const currentScrollPosition = getCurrentScrollPosition();
        setMaxScroll(curretnMaxScroll);
        setScrollPosition(currentScrollPosition + 5 > curretnMaxScroll ? curretnMaxScroll : currentScrollPosition);
    };
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const current = scrollableContainer === null || scrollableContainer === void 0 ? void 0 : scrollableContainer.current;
        if (current) {
            setMaxScroll(current.scrollWidth - current.clientWidth);
        }
        const resizeOb = new ResizeObserver(handleChange);
        const parent = document.querySelector(widgetContent);
        if (parent) {
            resizeOb.observe(parent);
            if (current) {
                resizeOb.observe(current);
            }
        }
        (_a = document.getElementById('widget-content')) === null || _a === void 0 ? void 0 : _a.addEventListener('resize', handleChange);
        (_b = document.getElementById('widget-content')) === null || _b === void 0 ? void 0 : _b.addEventListener('scroll', handleChange);
        current === null || current === void 0 ? void 0 : current.addEventListener('resize', handleChange);
        current === null || current === void 0 ? void 0 : current.addEventListener('scroll', handleChange);
        return current === null || current === void 0 ? void 0 : current.removeEventListener('scroll', () => {
            setScrollPosition(getCurrentScrollPosition());
        });
    }, [scrollableContainer]);
    let numOfVisibleArrows = 0;
    const prevArrowIsVisible = maxScroll !== 0 && scrollPosition > 0;
    const nextArrowIsVisible = maxScroll !== 0 && scrollPosition < maxScroll;
    const bothArrowsAreVisible = prevArrowIsVisible && nextArrowIsVisible;
    if (bothArrowsAreVisible) {
        numOfVisibleArrows = 2;
    }
    else if (prevArrowIsVisible || nextArrowIsVisible) {
        numOfVisibleArrows = 1;
    }
    return (react_1.default.createElement("div", { className: Carousel_module_scss_1.default.wrapper },
        prevArrowIsVisible && (react_1.default.createElement("div", { className: Carousel_module_scss_1.default.arrows, onClick: handlePrev },
            react_1.default.createElement(Image_1.default, { src: assets_1.svgSystemChevronLeft }))),
        react_1.default.createElement("div", { className: Carousel_module_scss_1.default.content, "data-num-of-visible-arrows": numOfVisibleArrows }, children),
        nextArrowIsVisible && (react_1.default.createElement("div", { className: Carousel_module_scss_1.default.arrows, onClick: handleNext },
            react_1.default.createElement(Image_1.default, { src: assets_1.svgSystemChevronRight })))));
});
Carousel.displayName = 'Carousel';
exports.default = Carousel;
